<template>
    <div style="background-color: white;box-sizing:unset;min-width:1600px">
        <headers></headers>
        <!-- 中间内容区域开始 -->
        <div class="container">
		<div class="wrapper" style="width: 1190px; margin-top: 30px; margin-bottom: 40px;">
		<!-- 中文版表格 -->
		<table v-if="langluageType != 'en'" class="table1" name="table">
			<thead>
				<tr>
					<th colspan="3">项目</th>
					<!-- <th>基础版</th> -->
					<th>专业版</th>
					<th>旗舰版</th>
					<th>旗舰版PLUS</th>
					<th>说明</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td rowspan="20" style="width: 110px;">基础功能</td>
					<td rowspan="13" style="width: 100px;">主场功能</td>
					<td>主场账号数量</td>
					<td>20个</td>
					<td>30个</td>
					<td>50个</td>
					<td>动态验证码</td>
				</tr>
				<tr>
					<td>自定义角色</td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td></td>
				</tr>
				<tr>
					<td>项目管理及设置</td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td>数据导入、信息管理、价格设定、规则制定、订单模板等</td>
				</tr>
				<tr>
					<td>在线审核</td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td>在线审图、在线订单、在线回执等</td>
				</tr>
				<tr>
					<td>图表导出</td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td>审核资料、报馆图纸、订单详情一键下载</td>
				</tr>
				<tr>
					<td>手动制单及修改</td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td></td>
				</tr>
				<tr>
					<td>项目一键设置</td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td>一键调取往届设置数据</td>
				</tr>
				<tr>
					<td>报馆流程设置</td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td></td>
				</tr>
				<tr>
					<td>商品加收设置</td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td></td>
				</tr>
				<tr>
					<td>价格分类管理与知识库分享</td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td></td>
				</tr>
				<tr>
					<td>通知信息</td>
					<td>PC端</td>
					<td colspan="2">PC端和小程序</td>
					<td>展会公告、答题设置、规章制度、临时通知</td>
				</tr>
				<tr>
					<td>资料上传</td>
					<td colspan="3">PC 端</td>
					<td>可上传报馆所需资料供用户下载，如手册</td>
				</tr>
				<tr>
					<td>自定义租赁商品图片</td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td>PC端和现场下单小程序同时展示</td>
				</tr>
				<tr>
					<td rowspan="3">报馆功能</td>
					<td>在线报馆、订单管理、发票管理、信息通讯</td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td></td>
				</tr>
				<tr>
					<td>资料下载</td>
					<td colspan="3">PC 端</td>
					<td>报馆用户可下载主场上传资料，如手册</td>
				</tr>
				<tr>
					
					<td>整改通知</td>
					<td >-</td>
					<td >PC 端</td>
					<td >PC端和小程序</td>
					<td></td>
				</tr>
				<tr>
					<td rowspan="3">财务功能</td>
					<td>订单信息、订单审核、发票信息、到账信息</td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td></td>
				</tr>
				<tr><td>押金管理</td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td></td>
				</tr>
				<tr><td>一键开票</td>
					<td>-</td>
					<td>-</td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td>仅提供系统内打通及调试，其他第三方费用由主场用户支付</td>
				</tr>
				<tr>
					<td>配套功能</td>
					<td>查询展位状态、报馆进度、部分资料下载</td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td>可供第三方开放</td>
				</tr>
				<tr><td rowspan="7">移动功能</td>
					<td rowspan="3">现场下单</td>
					<td>用户小程序下单</td>
					<td>-</td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td rowspan="7">仅负责部署和调试程序，其他第三方费用由主场用户支付</td>
				</tr>
				<tr><td>主场PC端订单、财务管理</td>
					<td>-</td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					
				</tr>
				<tr><td>实名证件认证</td>
					<td>-</td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					
				</tr>
				<tr><td rowspan="4">现场管理</td>
					<td>移动端巡查管理</td>
					<td>-</td>
					<td>-</td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					
				</tr>
				<tr><td>移动端资料查看</td>
					<td>-</td>
					<td>-</td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					
				</tr>
				<tr><td>移动端整改记录</td>
					<td>-</td>
					<td>-</td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					
				</tr>
				<tr><td>移动端展位验收</td>
					<td>-</td>
					<td>-</td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					
				</tr>
				<tr><td rowspan="2">品牌展示</td>
					<td>专属域名</td>
					<td>定制化专属域名</td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td></td>
				</tr>
				<tr><td>UI 页面</td>
					<td>独立的登陆页面</td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td>由用户提供画面</td>
				</tr>
				<tr><td rowspan="2">售后服务</td>
					<td rowspan="2">客户服务</td>
					<td rowspan="2">专属客服</td>
					<td rowspan="2"><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td rowspan="2"><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td rowspan="2"><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td rowspan="2">09:00-18:00（工作日）</td>
				</tr>
				<tr>
					<!-- <td></td>
					<td></td>
					<td></td>
					<td></td>
					<td></td> -->
				</tr>
				<tr><td rowspan="4">云端部署</td>
					<td rowspan="3">云服务器</td>
					<td>4核8GB 4Mpbs</td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td>-</td>
					<td>-</td>
					<td></td>
				</tr>
				<tr><td>8核16GB 8Mpbs</td>
					<td>-</td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td>-</td>
					<td></td>
				</tr>
				<tr><td>8核32GB 8Mpbs</td>
					<td>-</td>
					<td>-</td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td></td>
				</tr>
				<tr>
					<td rowspan="">数据存储</td>
					<td>系统云数据储存量</td>
					<td>2000 套</td>
					<td>3500 套</td>
					<td>5000 套</td>
					<td>云端报馆资料数据储存</td>
				</tr>
			</tbody>
		</table>
		<!-- 英文版表格 -->
		<table v-else class="table1" name="table">
			<thead>
				<tr>
					<th colspan="3">PROJECT</th>
					<!-- <th>基础版</th> -->
					<th>PROFESSIONAL</th>
					<th>ULTIMATE</th>
					<th style="width:150px">ULTIMATE PLUS</th>
					<th>Illustrate</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td rowspan="20" style="width: 110px;">Basic functions</td>
					<td rowspan="13" style="width: 100px;">Home function</td>
					<td>Number of accounts</td>
					<td>20</td>
					<td>30</td>
					<td>50</td>
					<td>Dynamic verification code</td>
				</tr>
				<tr>
					<td>Custom role</td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td></td>
				</tr>
				<tr>
					<td>Project management and setup</td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td>Data import, information management, price setting, rule formulation, order templates, etc.</td>
				</tr>
				<tr>
					<td>Online review</td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td>Online drawing review, online order, online receipt, etc.</td>
				</tr>
				<tr>
					<td>Chart export</td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td>One-click download of review materials, library drawings, and order details</td>
				</tr>
				<tr>
					<td>Manual order preparation and modification</td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td></td>
				</tr>
				<tr>
					<td>One-click project setting</td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td>Retrieve previous setting data with one click</td>
				</tr>
				<tr>
					<td>Library registration process settings</td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td></td>
				</tr>
				<tr>
					<td>Product add-on settings</td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td></td>
				</tr>
				<tr>
					<td>Price classification management and knowledge base sharing</td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td></td>
				</tr>
				<tr>
					<td>Notification information</td>
					<td>PC</td>
					<td colspan="2">PC＆mini program</td>
					<td>Exhibition announcements, question and answer settings, rules and regulations, temporary notices</td>
				</tr>
				<tr>
					<td>Data upload</td>
					<td colspan="3">PC</td>
					<td>Information required by the newspaper can be uploaded for users to download, such as manuals</td>
				</tr>
				<tr>
					<td>Customized rental product images</td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td>The PC client and the on-site ordering applet are displayed at the same time</td>
				</tr>
				<tr>
					<td rowspan="3">Newspaper function</td>
					<td>Online library registration, order management, invoice management, information communication</td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td></td>
				</tr>
				<tr>
					<td>Data download</td>
					<td colspan="3">PC</td>
					<td>Newspaper users can download materials uploaded by the venue, such as manuals</td>
				</tr>
				<tr>
					
					<td>Rectification notice</td>
					<td><img src="../assets/cpfa_kong.svg" alt=""></td>
					<td >PC</td>
					<td >PC＆mini program</td>
					<td></td>
				</tr>
				<tr>
					<td rowspan="3">Financial functions</td>
					<td>Order information, order review, invoice information, arrival information</td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td></td>
				</tr>
				<tr><td>Deposit management</td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td></td>
				</tr>
				<tr><td>One-click invoicing</td>
					<td><img src="../assets/cpfa_kong.svg" alt=""></td>
					<td><img src="../assets/cpfa_kong.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td>Only system access and debugging are provided, other third-party fees are paid by the home user.</td>
				</tr>
				<tr>
					<td>Supporting functions</td>
					<td>Check booth status, registration progress, and download some information</td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td>Available to third parties</td>
				</tr>
				<tr><td rowspan="7">Mobile functionality</td>
					<td rowspan="3">Mobile functionality</td>
					<td>User applet ordering</td>
					<td><img src="../assets/cpfa_kong.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td rowspan="7">Only responsible for deployment and debugging of the program, other third-party costs are paid by the home user</td>
				</tr>
				<tr><td>Home field PC order and financial management</td>
					<td><img src="../assets/cpfa_kong.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					
				</tr>
				<tr><td>Real-name ID authentication</td>
					<td><img src="../assets/cpfa_kong.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					
				</tr>
				<tr><td rowspan="4">Site Management</td>
					<td>Mobile inspection management</td>
					<td><img src="../assets/cpfa_kong.svg" alt=""></td>
					<td><img src="../assets/cpfa_kong.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					
				</tr>
				<tr><td>Mobile data viewing</td>
					<td><img src="../assets/cpfa_kong.svg" alt=""></td>
					<td><img src="../assets/cpfa_kong.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					
				</tr>
				<tr><td>Mobile version rectification record</td>
					<td><img src="../assets/cpfa_kong.svg" alt=""></td>
					<td><img src="../assets/cpfa_kong.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					
				</tr>
				<tr><td>Mobile booth acceptance</td>
					<td><img src="../assets/cpfa_kong.svg" alt=""></td>
					<td><img src="../assets/cpfa_kong.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					
				</tr>
				<tr><td rowspan="2">Brand display</td>
					<td>Exclusive domain name</td>
					<td>Customized exclusive domain name</td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td></td>
				</tr>
				<tr><td>UI page</td>
					<td>Separate landing page</td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td>Screen provided by user</td>
				</tr>
				<tr><td rowspan="2">After-sales service</td>
					<td rowspan="2">customer service</td>
					<td>Dedicated customer service</td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td></td>
				</tr>
				<tr><td>Online training</td>
					<td colspan="3">2 times/year</td>
					<td>Any excess will be charged separately</td>
				</tr>
				<tr><td rowspan="4">Cloud deployment</td>
					<td rowspan="3">Cloud server</td>
					<td>4 core 8GB 4Mpbs</td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_kong.svg" alt=""></td>
					<td><img src="../assets/cpfa_kong.svg" alt=""></td>
					<td></td>
				</tr>
				<tr><td>8 core 16GB 8Mpbs</td>
					<td><img src="../assets/cpfa_kong.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td><img src="../assets/cpfa_kong.svg" alt=""></td>
					<td></td>
				</tr>
				<tr><td>8 core 32GB 8Mpbs</td>
					<td><img src="../assets/cpfa_kong.svg" alt=""></td>
					<td><img src="../assets/cpfa_kong.svg" alt=""></td>
					<td><img src="../assets/cpfa_shi.svg" alt=""></td>
					<td></td>
				</tr>
				<tr>
					<td rowspan="">data storage</td>
					<td>System cloud data storage capacity</td>
					<td>2000 sets</td>
					<td>3500 sets</td>
					<td>5000 sets</td>
					<td>Cloud newspaper library information data storage</td>
				</tr>
			</tbody>
		</table>
		</div>

	</div>
        <!-- 中间内容区域结束 -->
        <footers></footers>
    </div>
</template>
<script>
  import headers from '@/components/Header';
  import footers from '@/components/Footer';

export default {
    components: {
      headers,
      footers,
    },
	data(){
		return {
			langluageType:sessionStorage.getItem('langluageType')||'ch'
		}
	}
}
</script>
<style scope>
	.foot-bd{position: relative}
	.table1{
        border-collapse:collapse;
        border: 1px solid #C0C4CC;
        border-color: #C0C4CC;
        width: 100%;
	}
    .table1 thead tr{
		background-color: #ddd;
		height: 50px;
		font-size: 14px;
        vertical-align: middle;
	}
        
	.table1 tbody tr{
		font-size: 14px;
		height: 50px;
        vertical-align: middle;
    }

    .table1 th,.table1 td{
		border: 1px solid #C0C4CC;
		padding: 0 10px;
        text-align: center;
        vertical-align: middle;
	}
	.table1 th:last-child,
	.table1 td:last-child{
		/* display: none; */
	}

	/* .table1 th:last-child(5),
	.table1 td:last-child(5){
		display: none;
	} */
    
    
</style>


// WEBPACK FOOTER //
// src/page/banben.vue